/*
 * JBeautyTR - Kargo Durum Kartı (motor)
 *
 * theme.liquid'den yüklenir, snippet'in içinden DEĞİL. Sebebi: Shopify
 * sepet çekmecesini innerHTML ile yeniden basıyor ve innerHTML ile
 * enjekte edilen <script> blokları tarayıcıda çalışmaz.
 *
 * PERFORMANS UYARISI — BURAYA MutationObserver EKLEMEYİN.
 * DOM'a yazan bir fonksiyonu body üzerinde subtree:true bir observer'a
 * bağlamak observer'ın kendini tetiklemesine yol açar ve sayfa kilitlenir.
 * Saniyede bir çalışan setInterval yeterli ve güvenlidir.
 *
 * Eurus kopyası: Dawn'daki assets/jbeauty-kargo-sayaci.js ile aynı motor.
 * Kademeler:
 *   > 1 saat        -> "Son H sa M dk"
 *   10 dk – 1 saat  -> "Son M dk"
 *   1 – 10 dk       -> "Son M dk SS sn"
 *   < 1 dk          -> "Son S saniye"
 * Aciliyet (kırmızı + nabız): kalan <= 30 dakika.
 *
 * Kesim saatleri (Türkiye saati, UTC+3 sabit):
 *   Pazartesi–Cuma 12:00 / Cumartesi 11:00 / Pazar yok / arife 11:00
 *   Resmi tatil: kargo çıkışı yok
 *
 * BAKIM: Tatil listelerine her yıl yeni tarihleri eklemek gerekir.
 */
(function () {
  if (window.__jbShipInit) return;
  window.__jbShipInit = true;

  var TR_OFFSET_MIN = 180;
  var URGENT_SEC = 1800;
  var COUNTDOWN_MAX_SEC = 40 * 3600;

  var JB_SHIP_HOLIDAYS = {
    '2026-08-30': 'Zafer Bayramı',
    '2026-10-29': 'Cumhuriyet Bayramı',
    '2027-01-01': 'Yılbaşı',
    '2027-03-09': 'Ramazan Bayramı',
    '2027-03-10': 'Ramazan Bayramı',
    '2027-03-11': 'Ramazan Bayramı',
    '2027-04-23': 'Ulusal Egemenlik ve Çocuk Bayramı',
    '2027-05-01': 'Emek ve Dayanışma Günü',
    '2027-05-16': 'Kurban Bayramı',
    '2027-05-17': 'Kurban Bayramı',
    '2027-05-18': 'Kurban Bayramı',
    '2027-05-19': 'Kurban Bayramı',
    '2027-07-15': 'Demokrasi ve Millî Birlik Günü',
    '2027-08-30': 'Zafer Bayramı',
    '2027-10-29': 'Cumhuriyet Bayramı'
  };

  var JB_SHIP_HALF_DAYS = {
    '2026-10-28': 'Cumhuriyet Bayramı arifesi',
    '2027-03-08': 'Ramazan Bayramı arifesi',
    '2027-05-15': 'Kurban Bayramı arifesi',
    '2027-10-28': 'Cumhuriyet Bayramı arifesi'
  };

  var DAY_NAMES = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

  function trNow() {
    var d = new Date();
    return new Date(d.getTime() + (d.getTimezoneOffset() + TR_OFFSET_MIN) * 60000);
  }

  function ymd(d) {
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function cutoffMinutes(date) {
    var key = ymd(date);
    if (JB_SHIP_HOLIDAYS[key]) return null;
    var day = date.getDay();
    if (day === 0) return null;
    if (JB_SHIP_HALF_DAYS[key]) return 11 * 60;
    if (day === 6) return 11 * 60;
    return 12 * 60;
  }

  function nextShippingDay(from) {
    var skipped = null;
    for (var i = 1; i <= 16; i++) {
      var d = new Date(from.getTime());
      d.setDate(d.getDate() + i);
      if (cutoffMinutes(d) !== null) return { date: d, offset: i, skipped: skipped };
      var n = JB_SHIP_HOLIDAYS[ymd(d)];
      if (n && !skipped) skipped = n;
    }
    return null;
  }

  function leadFor(next) {
    if (!next) return 'Siparişiniz ilk iş günü kargoda';
    if (next.offset === 1) return 'Yarın kargoda';
    return DAY_NAMES[next.date.getDay()] + ' kargoda';
  }

  function formatRemaining(total) {
    if (total >= 3600) {
      return 'Son <strong>' + Math.floor(total / 3600) + ' sa ' + Math.floor((total % 3600) / 60) + ' dk</strong>';
    }
    if (total >= 600) {
      return 'Son <strong>' + Math.floor(total / 60) + ' dk</strong>';
    }
    if (total >= 60) {
      return 'Son <strong>' + Math.floor(total / 60) + ' dk ' + pad2(total % 60) + ' sn</strong>';
    }
    return 'Son <strong>' + total + ' saniye</strong>';
  }

  function compute() {
    var now = trNow();
    var todayKey = ymd(now);
    var cutoff = cutoffMinutes(now);
    var nowMin = now.getHours() * 60 + now.getMinutes();
    var nowSec = now.getSeconds();

    if (cutoff !== null && nowMin < cutoff) {
      var total = (cutoff - nowMin) * 60 - nowSec;
      var sub = formatRemaining(total);
      var half = JB_SHIP_HALF_DAYS[todayKey];
      if (half) sub += ' · bugün ' + half + ', kargo 11:00';
      return { lead: 'Bugün kargoda', sub: sub, state: total <= URGENT_SEC ? 'urgent' : '' };
    }

    var next = nextShippingDay(now);
    if (!next) {
      return { lead: 'Siparişiniz ilk iş günü kargoda', sub: '', state: 'closed' };
    }

    var nextCutoff = cutoffMinutes(next.date);
    var target = new Date(next.date.getFullYear(), next.date.getMonth(), next.date.getDate(), 0, 0, 0, 0);
    target = new Date(target.getTime() + nextCutoff * 60000);
    var secs = Math.floor((target.getTime() - now.getTime()) / 1000);

    var sub2;
    if (secs > 0 && secs <= COUNTDOWN_MAX_SEC) {
      sub2 = formatRemaining(secs);
    } else {
      var todayHoliday = JB_SHIP_HOLIDAYS[todayKey];
      if (todayHoliday) {
        sub2 = todayHoliday + ' tatili';
      } else if (next.skipped) {
        sub2 = next.skipped + ' tatili';
      } else {
        sub2 = 'Hafta sonu kargo çıkışı yok';
      }
    }

    return { lead: leadFor(next), sub: sub2, state: 'closed' };
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-jb-ship]');
    if (!nodes.length) return;

    var r = compute();

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var leadEl = el.querySelector('[data-jb-ship-lead]');
      var subEl = el.querySelector('[data-jb-ship-sub]');
      if (!leadEl || !subEl) continue;

      if (el.getAttribute('data-jb-ship-lead-last') !== r.lead) {
        leadEl.textContent = r.lead;
        el.setAttribute('data-jb-ship-lead-last', r.lead);
      }

      if (el.getAttribute('data-jb-ship-sub-last') !== r.sub) {
        subEl.innerHTML = r.sub;
        el.setAttribute('data-jb-ship-sub-last', r.sub);
      }

      if (el.getAttribute('data-jb-ship-state') !== r.state) {
        el.classList.remove('jb-ship--urgent', 'jb-ship--closed');
        if (r.state) el.classList.add('jb-ship--' + r.state);
        el.setAttribute('data-jb-ship-state', r.state);
      }
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
